import Cookie from "./cookie.js"
import m from 'mithril'


var Location = {
  lat: Cookie.get("loc.lat") || "37.423084",
  long: Cookie.get("loc.long") || "-122.139672",
  name: Cookie.get("loc.name"),
  zip: Cookie.get("loc.zip"),
  init: function() {
    return Promise.resolve()
    .then(function(){
      if (Location.zip) return Location.zip;
      return Location.ask();
    }).then(function(zip) {
      if (Location.name) return Location;
      return Location.fetchMetadata()
    }).then(function() {
      return Location
    });
  },
  ask: function(callback) {
    return new Promise(function(resolve) {
      var zip = prompt("Please enter the location to show weather for", Location.zip || "12345")
      
      if (zip) {
        Cookie.set("loc.zip", zip)
        Location.zip = zip
        resolve(Location.fetchMetadata(callback));
      }
    })
  },
  fetchMetadata: function() {
    var query = Location.zip || "94306" ;
    var geocodeUrl = "https://maps.googleapis.com/maps/api/geocode/json?address="+ query +"&key=AIzaSyAAxJm8ICyfZYomZj2MRSFc7WPk2VdHR74"
    return m.request({method: "GET", url: geocodeUrl})
    .then(function(response) {
      if (response.error_message) {
          console.error(response.error_message)
      } else {

          var result = response.results[0]
          var loc = result.geometry.location;

          // console.log("filtering" + JSON.stringify(result.address_components))
          var name = result.address_components.filter(function(c){
            return c.types.indexOf("locality") !== -1;
          })
          
          name = name .pop().short_name || result.formatted_address ;

          Cookie.set("loc.lat", loc.lat)
          Cookie.set("loc.long", loc.long)
          Cookie.set("loc.name", name)
          Location.lat = loc.lat;
          Location.long = loc.lng; 
          Location.name = name
          return Location
      }
    })
  },

  request: function() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      Location.ask();
    }
  }
}

module.exports = Location